<template>
  <router-link
    class="item"
    v-if="app && app.id"
    :class="{ active: active }"
    :to="{ name: 'app-settings', params: { appId: app.id } }"
  >
    <div class="row header">
      <i
        class="icon applicationTypeIcon"
        :class="appType && appType.icon"
        :style="{ color: appType && appType.color }"
      />
      <div class="ellipsis appName" :title="app.name" v-html="nameWithHighlights"></div>
      <div class="ui basic blue tiny label" v-if="app.appVersion">{{ app.appVersion }}</div>
    </div>
    <div class="row secondRow">
      <div
        class="manufacturer ellipsis"
        :title="(app.manufacturerObject && app.manufacturerObject.name) || $t('UNKNOWN')"
      >
        {{ (app.manufacturerObject && app.manufacturerObject.name) || $t('UNKNOWN') }}
      </div>
      <multi-color-label class="flowMultiColorLabel" size="tiny" :colors="appGroupColors" />
    </div>
  </router-link>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';

.row {
  display: flex;
  align-items: center;
}

.ellipsis {
  width: 85%;
}

.flowMultiColorLabel {
  margin-left: 3em;
}

.applicationTypeIcon {
  margin-right: 0.4rem;
}

.appName {
  margin-left: 0.1rem;
}

.secondRow {
  margin-left: 1.6rem;
}
</style>
<script>
// @flow
import { MultiColorLabel } from 'ui'
import { Application } from 'services'

export default {
  name: 'singleapplication',
  components: { MultiColorLabel },
  props: ['app', 'active', 'appGroupColors', 'appType', 'nameWithHighlights']
}
</script>
